module.exports = __webpack_public_path__ + "static/media/wab32_1010.ddbad981.ico";